import { jsx as _jsx } from "react/jsx-runtime";
import { Square, SpinnerContainer } from "./spinner.styles";
export function Spinner({ inverted = false, animationDuration = 0.6, size = "standard", }) {
    function renderSquares() {
        const squares = [];
        for (let index = 1; index < 5; index += 1) {
            squares.push(_jsx(Square, { index: index, row: index <= 2 ? 1 : 2, column: index % 2 !== 0 ? 1 : 2, animationDuration: animationDuration, inverted: inverted, size: size }, `square-${String(index)}`));
        }
        return squares;
    }
    return _jsx(SpinnerContainer, Object.assign({ size: size }, { children: renderSquares() }));
}
